import {createClient} from 'contentful';

const config_old = {
    space: "g7zopbybs1ea",
    accessToken: "KUpDlj0KIgIaTmDU6Sk9mMk1SiRCSMFToUsMRyFM9pc"
};

const config_new = {
    space: "yso50nbaghtr",
    accessToken: "ZmXRRszHjULqjV6RasfGDfMCOHzP6IlBdw9PcvzfhTI"
};

const config_dev = {
    space: "0x5o817yoioj",
    accessToken: "rj5RLvBlKd5v7CheYOO5b0toiGboLZU7zzd_Qckc41U"
};


export default class Contentful {
    protected static _instance: Contentful = new Contentful();
    client = createClient(config_new);
    private entryCache: Map<string, any> = new Map();
    private entriesCache: Map<string, any> = new Map();
    private assetCache: Map<string, any> = new Map();
    private assetsCache: Map<string, any> = new Map();

    constructor() {
        if(Contentful._instance) {
            throw new Error("Instantiation failed");
        }
    }

    public static getInstance(): Contentful {
        return Contentful._instance
    }

    async getEntry(id: string) {
        if (this.entryCache.has(id)) return this.entryCache.get(id);
        const entry = await this.client.getEntry(id);
        this.entryCache.set(id, entry);
        return entry;
    }

    async getEntries(query: any) {
        const key = JSON.stringify(query);
        if (this.entriesCache.has(key)) return this.entriesCache.get(key);
        const entries = await this.client.getEntries(query);
        this.entriesCache.set(key, entries);
        return entries;
    }

    async getAsset(id: string) {
        if (this.assetCache.has(id)) return this.assetCache.get(id);
        const asset = await this.client.getAsset(id);
        this.assetCache.set(id, asset);
        return asset;
    }

    async getAssets(query: any) {
        const key = JSON.stringify(query);
        if (this.assetsCache.has(key)) return this.assetsCache.get(key);
        const assets = await this.client.getAssets(query);
        this.assetsCache.set(key, assets);
        return assets;
    }
}
